import React, { useState } from 'react';
import { Search, SlidersHorizontal } from 'lucide-react';
import { useVenueStore } from '../store/useVenueStore';
import { useTranslation } from 'react-i18next';
import { FilterBar } from './FilterBar';

export const SearchBar: React.FC = () => {
  const { setSearchQuery } = useVenueStore();
  const { t } = useTranslation();
  const [showFilters, setShowFilters] = useState(false);

  return (
    <div className="bg-white w-full p-4 shadow-md rounded-lg mb-4">
      <div className="relative mb-3">
        <input
          type="text"
          placeholder={t('search.placeholder')}
          className="w-full px-10 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fabddf]"
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
      </div>
      
      <button
        onClick={() => setShowFilters(!showFilters)}
        className="w-full flex items-center justify-center py-2 px-4 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 transition-colors"
      >
        <SlidersHorizontal className="mr-2 w-4 h-4" />
        <span>{showFilters ? t('filters.hideFilters') : t('filters.showFilters')}</span>
      </button>
      
      {showFilters && <FilterBar />}
    </div>
  );
};